// src/lib/rebrand.js
// Marque configurable (build ARTICHAUT) : remplace « Artkiv/ARTKIV » dans des textes.
// Sans effet quand la marque reste ARTKIV. Les URL, e-mails et identifiants (artkivLabels…)
// sont intacts ; les rubriques contractuelles ou de consentement gardent l'entité ARTKIV.
import { BRAND_NAME } from "../config/brand";
import { VISION_URL } from "../config/domains";

// Hôte Vision du build (ex. vision.artichaut.eu). Les textes affichés qui citent « vision.artkiv.com »
// doivent suivre le build : sinon un visiteur d'ARTICHAUT lit l'adresse d'ARTKIV.
const VISION_HOST = (() => {
  try { return new URL(VISION_URL).hostname; } catch { return "vision.artkiv.com"; }
})();

const LEGAL_PREFIXES = [
  "partner.contract",
  "expertBillingManager",
  "icmsSubscription",
  "aiConsentInfoPage",
  "consentIA",
  "aiDisclosure",
  "profile.ia",
  "artwork.accessPrivacy",
];

export const BRAND_UPPER = BRAND_NAME.toUpperCase();
// Règle de marque : ARTICHAUT s'écrit toujours en capitales, même au milieu d'une phrase
// (et dans les PDF/exports). ARTKIV (build par défaut) garde sa casse « Artkiv ».
export const BRAND_TITLE =
  BRAND_UPPER === "ARTICHAUT"
    ? BRAND_UPPER
    : BRAND_NAME.charAt(0).toUpperCase() + BRAND_NAME.slice(1).toLowerCase();
const ACTIVE = BRAND_UPPER !== "ARTKIV";

export function rebrandString(s) {
  if (!ACTIVE) return s;
  return s
    .replace(/(?<![@/.\w])(Artkiv|ArtKiv|ARTKIV)(?!\w|\.[a-z])/g, (m) => (m === "ARTKIV" ? BRAND_UPPER : BRAND_TITLE))
    .replace(/\bvision\.artkiv\.com\b/g, VISION_HOST);
}

function walk(node, path) {
  if (typeof node === "string") return rebrandString(node);
  if (Array.isArray(node)) return node.map((v) => walk(v, path));
  if (node && typeof node === "object") {
    if (LEGAL_PREFIXES.some((p) => path === p || path.startsWith(p + "."))) return node;
    const out = {};
    for (const k of Object.keys(node)) out[k] = walk(node[k], path ? `${path}.${k}` : k);
    return out;
  }
  return node;
}

export function rebrandTree(tree) {
  return ACTIVE ? walk(tree, "") : tree;
}

// Plugin i18next : applique le remplacement à TOUT résultat de t(), y compris les
// textes `defaultValue` écrits dans le code (absents des fichiers de traduction).
export const rebrandPlugin = ACTIVE
  ? {
      type: "postProcessor",
      name: "rebrand",
      process(value, key) {
        if (typeof value !== "string") return value;
        const k = String(Array.isArray(key) ? key[0] : key || "");
        if (LEGAL_PREFIXES.some((p) => k === p || k.startsWith(p + "."))) return value;
        return rebrandString(value);
      },
    }
  : null;
